import { paramBuilder, routeToSpecificScope } from '../../helpers';
import * as TYPES from '../types';
import { requestData } from '../../config/services/datasets';
import { SERVER } from '../../config/server.config';
import { addLoadingFlag, subLoadingFlag } from '.';
import { ConferenceType, TeamsAction, TeamsResponse, TeamsType } from '../types';
import { Dispatch } from 'redux';
import { RootState } from '../reducers';

export const replaceTeamsStandings = (teams: TeamsResponse) => {
  return {
    type: TeamsAction.UPDATE_TEAMS_STANDINGS,
    teams: teams
  };
};

export const getTeamsStandings = () => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));
    const params = getState().filters[scope] ? JSON.parse(JSON.stringify(getState().filters[scope])) : {};
    const paramsRequest = paramBuilder(params);
    const results = await requestData(SERVER.TEAMS + (paramsRequest ? '?' + paramsRequest : ''));
    if (results) {
      const teams: {AFC: ConferenceType, NFC: ConferenceType} = {
        AFC: results[0].AFC.reduce((obj: ConferenceType, item: TeamsType) => {
          obj[item.teamId] = item;
          return obj;
        }, {}),
        NFC: results[0].NFC.reduce((obj: ConferenceType, item: TeamsType) => {
          obj[item.teamId] = item;
          return obj;
        }, {})
      };
      dispatch(replaceTeamsStandings(teams));
    }
    dispatch(subLoadingFlag(scope));
  };
};



